import { Col, Row, Typography } from '@repo/ui/components'
import { ValueWithUnit, PaymentType, ToDateTime } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { AgentOTCTransaction } from '@repo/services'
import { useIsDesktop } from '@repo/ui/hooks'
import { HistoryDetailsDialog } from './history-details.dialog'

export const HistoryItem = (props: AgentOTCTransaction) => {
  const { agentAmount, createdAt, order } = props

  const { t } = useTranslate()
  const isDesktop = useIsDesktop()

  return (
    <HistoryDetailsDialog {...props}>
      <div className='cursor-pointer'>
        {isDesktop ? (
          // Desktop Layout
          <Row className='justify-between items-start gap-md py-lg px-md border-b border-neutral-surface-5 last:border-b-0'>
            <Col className='gap-xs flex-1'>
              <Row className='gap-xs items-center'>
                <Typography
                  size='xs'
                  color={
                    order?.orderType === 'buy'
                      ? 'text-positive-surface-100'
                      : 'text-negative-surface-100'
                  }
                >
                  {order?.orderType === 'buy'
                    ? t('history_buy')
                    : t('history_sell')}
                </Typography>
                <Typography size='sm' className='text-neutral-surface-80'>
                  <ToDateTime date={new Date(createdAt ?? '')} />
                </Typography>
              </Row>
              <Typography size='xs' className='text-neutral-main'>
                {order?.targetCurrency}
              </Typography>
            </Col>

            <Row className='gap-md items-center justify-between w-fit'>
              <Col className='gap-md items-center'>
                <Typography size='sm' className='text-neutral-surface-80'>
                  {t('history_amount')}
                </Typography>
                <Typography size='sm'>
                  <ValueWithUnit
                    value={order?.targetAmount ?? 0}
                    unitSize='sm'
                    valueSize='sm'
                    unit='property'
                  />
                </Typography>
              </Col>
              <Col className='gap-md items-center'>
                <Typography size='xs' className='text-neutral-surface-80'>
                  {t('history_income')}
                </Typography>
                <PaymentType value={agentAmount} size='md' />
              </Col>
            </Row>
          </Row>
        ) : (
          // Mobile Layout
          <Row className='justify-between items-start gap-md py-lg px-md border-b border-neutral-surface-5 last:border-b-0'>
            <Col className='gap-xs flex-1'>
              <Row className='gap-xs items-center justify-between'>
                <Typography
                  size='xs'
                  color={
                    order?.orderType === 'buy'
                      ? 'text-positive-surface-100'
                      : 'text-negative-surface-100'
                  }
                >
                  {order?.orderType === 'buy'
                    ? t('history_buy')
                    : t('history_sell')}
                </Typography>
                <Typography size='xs' className='text-neutral-surface-80'>
                  <ToDateTime date={new Date(createdAt ?? '')} />
                </Typography>
              </Row>
              <Typography size='xs' className='text-neutral-main'>
                {order?.targetCurrency}
              </Typography>
              <Row className='gap-md items-center justify-between'>
                <Row className='items-center'>
                  <Typography size='xs'>
                    <ValueWithUnit
                      id='4'
                      value={order?.targetAmount ?? 0}
                      unitSize='sm'
                      valueSize='sm'
                      unit='property'
                    />
                  </Typography>
                </Row>
                <Row className='gap-2xs items-center justify-end'>
                  <Typography size='xs' className='text-neutral-surface-80'>
                    {t('history_income')}
                  </Typography>
                  <PaymentType value={agentAmount} size='sm' />
                </Row>
              </Row>
            </Col>
          </Row>
        )}
      </div>
    </HistoryDetailsDialog>
  )
}
